import { ReactInstaStories } from "../../../react-insta-stories/reactInstaStories";
import { Story } from "../../../react-insta-stories/interfaces";
import { StoriesEntity } from "./storiesAutoComponenta";
import { SiteMedia } from "../../../../siteWidgets/siteMedia";
import { FrontCopyButton } from "../../../../commonComponents/inline/frontCopyButton/frontCopyButton";
import * as classNames from "classnames"

interface StoriesItemProps {
    entity: StoriesEntity
    activeEntityIndex: number
    index: number
    numberOfEntities: number
    storiesProgressTime: number
    lang: string
    handleNextSlide: () => void
    handlePrevSlide: () => void
    handleFinishedStories: () => void
    onStorySelect: (index: number) => void
    onAllStoriesEnd: (nextSlideIndex: number) => void
}

interface StoriesItemState {
    stories: Story[]
    currentIndex: number
    isMuted: boolean
}

const DICT = {
    "he": {
        "The link has been copied to the clipboard": "הקישור הועתק ללוח",
    },
    "ar": {
        "The link has been copied to the clipboard":"تم نسخ الرابط إلى الحافظة"
    }
}

export class StoriesItem extends React.Component<StoriesItemProps, StoriesItemState> {
    constructor(props) {
        super(props);
        this.state = {
            stories: [],
            currentIndex: 0,
            isMuted: false,
        }
    }

    componentDidMount() {
        const { entity: { slotId } } = this.props;
        this.getStories();
        this.getStoryCurrentIndex(slotId);
    }

    componentDidUpdate(prevProps) {
        const { entity: { slotId }, activeEntityIndex } = this.props;
        if (prevProps.activeEntityIndex !== activeEntityIndex) this.getStoryCurrentIndex(slotId);
    }

    componentWillUnmount() {
        const { entity: { slotId }, handleFinishedStories } = this.props;
        this.getStoryCurrentIndex(slotId);
        handleFinishedStories();
    }

    public getStories() {
        const { entity } = this.props;
        const {shouldDisplayStoryTitle} = entity;
        const {isMuted} = this.state;
        const storiesArray = entity.linkedItems.map((linkedItem) => {
            const isVideoStory = linkedItem.hasVideo;
            const url = isVideoStory && linkedItem.video ? linkedItem.video[0].high_res_link : linkedItem.promotionImageDetails.url;
            return { url, type: isVideoStory ? 'video' : "", link: linkedItem.publishedLink, header: {heading: linkedItem.title, subheading:"", profileImage:""}, storyClasses: shouldDisplayStoryTitle && linkedItem.specialData.titlePosition.value, muted: isMuted }
        });
        this.setState({ stories: storiesArray });
    }

    public setStoryCurrentIndex = (slotId: string, index: number) => {
        localStorage.setItem(slotId, index.toString())
    }

    public getStoryCurrentIndex = (slotId: string) => {
        const currentIndex = localStorage.getItem(slotId);
        this.setState({ currentIndex: +currentIndex });
    }

    public onNextStory = () => {
        const { currentIndex, stories, isMuted } = this.state;
        const { entity: { slotId }, handleNextSlide } = this.props;
        if (currentIndex === stories.length - 1) return handleNextSlide();
        const updatedStories = stories.map((story) => ({...story, muted: isMuted}));

        this.setState({ currentIndex: this.state.currentIndex + 1, stories: updatedStories }, () => this.setStoryCurrentIndex(slotId, this.state.currentIndex));
    }

    public onPrevStory = () => {
        const { currentIndex, stories, isMuted } = this.state;
        const { entity: { slotId }, handlePrevSlide } = this.props;
        const updatedStories = stories.map((story) => ({...story, muted: isMuted}));
        if (currentIndex === 0) return handlePrevSlide();

        this.setState({ currentIndex: this.state.currentIndex - 1, stories:updatedStories }, () => this.setStoryCurrentIndex(slotId, this.state.currentIndex));
    }
 
    public onStoryEnd = () => {
        const { entity: { slotId } } = this.props;
        const { currentIndex, stories, isMuted } = this.state;
        const updatedStories = stories.map((story) => ({...story, muted: isMuted}));
        if (currentIndex === stories.length - 1) return;

        this.setState({ currentIndex: this.state.currentIndex + 1, stories: updatedStories }, () => this.setStoryCurrentIndex(slotId, this.state.currentIndex));
    }

    public onToggleMute = () => {
        const videoElement = document.querySelector(".storiesDisplayWrapper .splide__slide.is-active .storyContent video") as HTMLVideoElement;
        if (!videoElement) return;
        videoElement.muted ? this.setState({ isMuted: false }, () => videoElement.muted = false) : this.setState({ isMuted: true }, () => videoElement.muted = true);
    }

    public onEntitySelect = () => {
        const {onStorySelect, index} = this.props;
        const {stories, isMuted} = this.state;
        const updatedStories = stories.map((story) => ({...story, muted: isMuted}));

        this.setState({stories: updatedStories}, () => onStorySelect(index));
    }

    public render() {
        const { stories, currentIndex, isMuted } = this.state;
        const isStoriesExist = stories.length;
        const { entity, index, activeEntityIndex, lang, onAllStoriesEnd, numberOfEntities, storiesProgressTime } = this.props;
        const {promotionName, media, linkTarget, link, shouldDisplayStoryTitle} = entity;
        if (!stories) return null;

        const isMainStory = index === activeEntityIndex;
        const isFirstStory = currentIndex === 0 && activeEntityIndex === 0;
        const isLastStory = stories ? (currentIndex === stories.length - 1 && activeEntityIndex === numberOfEntities - 1) : false;
        const isCurrentStoryHasVideo = stories && stories[currentIndex] && stories[currentIndex].type === "video";
        const millisecDefaultInterval = storiesProgressTime * 1000;
        const slotClass = classNames("slotView", {"muted": isMuted, "firstStory": isFirstStory, "lastStory": isLastStory, "videoStory": isCurrentStoryHasVideo});
        const storyClass = `mainStory ${shouldDisplayStoryTitle ? "withHeader" : ""}`;

        return (
            <div className={slotClass}>
                <div className="storyItems">
                    {isMainStory && isStoriesExist  ?
                        <div className={storyClass}>
                            <div className="muteBtn" onClick={this.onToggleMute}></div>

                            <ReactInstaStories
                                stories={stories}
                                defaultInterval={millisecDefaultInterval}
                                width={400}
                                height={709}
                                onNext={this.onNextStory}
                                onPrevious={this.onPrevStory}
                                onAllStoriesEnd={() => onAllStoriesEnd(index + 1)}
                                currentIndex={currentIndex}
                                onStoryEnd={this.onStoryEnd}
                                preventDefault={true}
                            />
                            <div className="moreDetails" >
                                <div className="mediaArea">
                                    <div className="MediaCarousel">
                                        <SiteMedia
                                            data={media}
                                            width={50}
                                            height={50}
                                            videoSettings={null}
                                            itemLinkUrl={link.link.publishedLink}
                                            isImageLinkable={true}
                                            linkTarget={linkTarget}
                                        />
                                    </div>
                                    <div className="slotTitle">{promotionName}</div>
                                </div>
                                <FrontCopyButton popupText={DICT[lang][["The link has been copied to the clipboard"]]} url={stories[currentIndex] ? stories[currentIndex].link : null} classes="shareBtn" />
                            </div>
                        </div>
                        :
                        <div className="storyPlaceholder" onClick={this.onEntitySelect}>
                            <div className="MediaCarousel">
                                <SiteMedia
                                    data={media}
                                    width={100}
                                    height={100}
                                    videoSettings={null}
                                    itemLinkUrl={link.link.publishedLink}
                                    isImageLinkable={true}
                                    linkTarget={linkTarget}
                                />
                            </div>
                            <div className="slotTitle">{promotionName}</div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}